/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * Payout
 * Payout application
 * OpenAPI spec version: 1.0
 */

export enum PayoutCommonOrderTraderOrderV1PublicStatus {
    PUBLIC_STATUS_UNSPECIFIED = 'PUBLIC_STATUS_UNSPECIFIED',
    PUBLIC_STATUS_CREATED = 'PUBLIC_STATUS_CREATED',
    PUBLIC_STATUS_PENDING = 'PUBLIC_STATUS_PENDING',
    PUBLIC_STATUS_COMPLETED = 'PUBLIC_STATUS_COMPLETED',
    PUBLIC_STATUS_FAILED = 'PUBLIC_STATUS_FAILED',
    PUBLIC_STATUS_MISSED = 'PUBLIC_STATUS_MISSED',
    PUBLIC_STATUS_DECLINED_BY_TRADER = 'PUBLIC_STATUS_DECLINED_BY_TRADER',
}
